import useMeetData from '@usas/ui-web/state/meet/UseMeetData';

const useMeetSessionsDetail = () => {
  const { meetState } = useMeetData();

  return {
    meetState
  };
};

export default useMeetSessionsDetail;